import React from "react";
import mapNL from "../../../assets/tennet-kaartnl-250520.png";
import "./styles.scss";

function Map({ title }) {
  return (
    <div className="el-map-nl">
      <h3 className="heading--text">{title}</h3>
      <img src={mapNL} alt="Kaart Tennet NL" />
    </div>
  );
}

export default Map;
